export { WebsiteSchema } from "./website-schema";
export type { WebsiteSchemaProps } from "./website-schema.types";